import { render, staticRenderFns } from "./ZygoteRationale.vue?vue&type=template&id=a86a3b60&"
import script from "./ZygoteRationale.vue?vue&type=script&lang=js&"
export * from "./ZygoteRationale.vue?vue&type=script&lang=js&"
import style0 from "./ZygoteRationale.vue?vue&type=style&index=0&id=a86a3b60&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports